import { Skeleton, TableSkeleton } from '../Skeleton';
import { TableEmptyState } from './TableEmptyState';

interface TableLoadingProps {
  /** @deprecated Pass `isLoading` to `BPMTable` / `ModalEditWidget` instead. */
  isLoading: boolean;
  // Any truthy value (an Error, a string, etc.) routes to errorMessage instead of emptyMessage.
  error?: unknown;
  errorMessage?: string;
  emptyMessage?: string;
  rowHeight?: number;
  headerHeight?: number;
}

// The canonical noRowsRenderer body for a BPMTable that's always mounted: a skeleton while
// fetching, an error-specific message if the query settled as an error, otherwise the shared
// empty state. Pass rowHeight/headerHeight matching the real table's own so the skeleton's row
// sizing lines up with what replaces it.
export const TableLoading = ({
  isLoading,
  error,
  errorMessage = "Couldn't load data",
  emptyMessage,
  rowHeight,
  headerHeight
}: TableLoadingProps) => {
  if (isLoading) {
    return (
      <Skeleton dataTestId='table-skeleton'>
        <TableSkeleton rowHeight={rowHeight} headerHeight={headerHeight} yOffset={8} />
      </Skeleton>
    );
  }
  if (error) {
    return <TableEmptyState message={errorMessage} />;
  }
  return <TableEmptyState message={emptyMessage} />;
};
